<template>
    <common-page flex-column>
        <div id="project-info" class="content">
            <div class="card">
                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                     data-parent="#accordionFilter">
                    <div class="card-body">
                        <h5><span class="text-primary">用户组信息</span></h5>
                        <h6>名称：{{ userGroupName }}</h6>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mt-1 p-2">
            <div class="d-flex align-items-center">
                <h5 class="text-primary mb-0">{{ '角色列表' }}</h5>
                <button class="btn btn-primary ml-3 ont-size-15" type="button" title="添加协议"
                        @click="openSelectDialog()">
                    添加角色
                </button>
            </div>
            <b-overlay :show="savingUserGroupRoleList || queryUserGroupRoleListLoading">
                <mini-table ref="UserGroupRoleListResultTable"
                            read-only
                            needModelFields
                            :items="currentRoleList"
                            :withCustomActionsEndOfRow=true
                            style="min-height: 350px;"
                            :row-key="'id'"
                            entity-name="emAclRole">
                    <template #rightHeader>
                        <b-button class="ml-1" variant="success"
                                  :disabled="savingUserGroupRoleList"
                                  v-show="editAble"
                                  @click="saveUserGroupRoleList()">
                            保 存
                        </b-button>
                        <b-button class="ml-1 mr-1" :variant="editAble ? 'outline-warning' : 'outline-success'"
                                  v-if="currentRoleList.length > 0"
                                  @click="triggerTableEdit()">
                            {{ editAble ? '关闭编辑' : '开启编辑' }}
                        </b-button>
                    </template>
                    <template #endOfRow="{row}">
                        <b-button variant="danger" v-if="editAble"
                                  @click="deleteSelectedRow(row)">
                            <i class="fa-solid fa-trash-can"></i>
                        </b-button>
                    </template>
                </mini-table>
            </b-overlay>
        </div>
        <template #outer>
            <el-dialog title="添加角色" :visible.sync="selectRoleDialogVisible" width="85%"
                       :close-on-click-modal='false' append-to-body
                       @close='clearFilter'>
                <!-- 筛选框部分 -->
                <div>
                    <el-form :model="aclRoleQueryForm" ref="filterForm" label-width="auto" size="mini">
                        <el-row :gutter="10">
                            <el-col :span="6">
                                <el-form-item label="名称">
                                    <el-input v-model="aclRoleQueryForm.nameFilter"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="类型">
                                    <el-select v-model="aclRoleQueryForm.typeFilter" clearable>
                                        <el-option v-for="item in aclRoleTypes"
                                                   :key="item.value"
                                                   :label="item.label"
                                                   :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="状态">
                                    <el-select v-model="aclRoleQueryForm.statusFilter" clearable>
                                        <el-option v-for="item in aclRoleStatus"
                                                   :key="item.value"
                                                   :label="item.label"
                                                   :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <!-- 搜索和重置按钮 -->
                        <el-row>
                            <el-col :span="4" :offset="10">
                                <el-button type="primary" plain @click="searchItems" icon="el-icon-search"
                                           size="mini"
                                           :loading="inQuery">查询
                                </el-button>
                                <el-button type="warning" plain @click="resetFilter" icon="el-icon-delete" size="mini">
                                    重置
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- 显示协议选择部分 -->
                <div class="mt-1">
                    <div class="row">
                        <div class="col-6">
                            <mini-table :items="searchResult"
                                        read-only
                                        needModelFields
                                        entity-name="emAclRole"
                                        :hideCustomizeFieldButton=true
                                        @rowClick="chooseItem"></mini-table>
                        </div>
                        <div class="col-6">
                            <mini-table :items="chosenItems" read-only
                                        header-title="已选择"
                                        needModelFields
                                        :hideCustomizeFieldButton=true
                                        entity-name="emAclRole"
                                        @rowClick="handleDelete"></mini-table>
                        </div>
                    </div>
                    <div class="mt-1 d-flex flex-row">
                        <el-button class="ml-auto" @click="selectRoleDialogVisible=false">取消</el-button>
                        <el-button class="ml-1" type="primary" @click="assignRoleToUserGroup()">确认
                        </el-button>
                    </div>
                </div>
            </el-dialog>
        </template>

    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "../../../utils/commonViewsUtil";

export default {
    name: "EmEmAdmGroupSubUserList",
    mixins: [emCommonListMixin, emCommonApiMixin],
    components: {CommonPage, MiniTable},
    data() {
        return {
            queryUserGroupRoleListLoading: false,
            selectRoleDialogVisible: false,
            savingUserGroupRoleList: false,
            editAble: false,
            aclRoleQueryForm: {
                nameFilter: '',
                typeFilter: null,
                statusFilter: null
            },
            aclRoleTypes: [
                {
                    label: '管理员',
                    value: 1
                }, {
                    label: '普通用户',
                    value: 2
                }
            ],
            aclRoleStatus: [
                {
                    label: '启用',
                    value: 1
                }, {
                    label: '禁用',
                    value: 2
                }
            ],
            originRoleList: [],
            currentRoleList: [],
            addedRoleIds: [],
            needDeleteRoleIds: [],
            inQuery: false,
            searchResult: [],
            chosenItems: []
        }
    },
    created() {
        this.queryUserGroupRoleList();
        this.addedRoleIds = [];
        this.needDeleteRoleIds = [];
    },
    computed: {
        userGroupName() {
            return this.$route.query.userGroupName
        },
        userGroupId() {
            return this.$route.query.userGroupId;
        },
        entityName() {
            return "emAclRole";
        }
    },
    methods: {
        queryUserGroupRoleList() {
            this.queryUserGroupRoleListLoading = true
            let url = this.$_emApiMixin_entityBaseApi("emEmAdmUserGroupRole") + "/getRolesByUserGroup?userGroupId=" + this.userGroupId;
            this.$_emApiMixin_get(url, false)
                .then(response => {
                        this.originRoleList = response
                        this.currentRoleList = response;
                    }
                ).finally(() => this.queryUserGroupRoleListLoading = false)
        },
        assignRoleToUserGroup() {
            let currentUserGroupRoleIds = this.currentRoleList.map(item => item.id);
            const originUserGroupRoleIds = this.originRoleList.map(item => item.id)
            this.chosenItems.forEach(item => {
                if (!currentUserGroupRoleIds.includes(item.id)) {
                    this.currentRoleList.push(item);
                    if (!originUserGroupRoleIds.includes(item.id)) {
                        this.addedRoleIds.push(item.id);
                    }
                }
            });
            this.selectRoleDialogVisible = false;
            this.triggerTableEdit(true);
        },
        triggerTableEdit(val) {
            if (val !== undefined) {
                this.editAble = val;
            } else {
                this.editAble = !this.editAble;
            }
        },
        clearFilter() {
            this.inQuery = false;
            this.chosenItems = [];
        },
        searchItems() {
            this.inQuery = true
            this.$_emApiMixin_findByFilter(this.entityName, this.aclRoleQueryForm).then((response) => {
                this.searchResult = response;
            }).finally(() => this.inQuery = false);
        },
        resetFilter() {
            this.searchResult = [];
            this.aclRoleQueryForm.nameFilter = '';
            this.aclRoleQueryForm.typeFilter = '';
            this.aclRoleQueryForm.statusFilter = '';
        },
        chooseItem(row) {
            let indexOf = this.chosenItems.indexOf(row);
            if (indexOf === -1) {
                this.chosenItems.push(row);
            } else {
                this.chosenItems.splice(indexOf, 1);
            }
        },
        handleDelete(row, index) {
            this.chosenItems.splice(index, 1);
        },
        openSelectDialog() {
            this.selectRoleDialogVisible = true;
        },
        deleteSelectedRow(row) {
            const index = this.currentRoleList.findIndex(item => item.id === row.id);
            const originRoleIds = this.originRoleList.map(item => item.id)
            if (index !== -1) {
                this.currentRoleList.splice(index, 1);
                if (originRoleIds.includes(row.id)) {
                    this.needDeleteRoleIds.push(row.id);
                }
            }
        },
        saveUserGroupRoleList() {
            this.savingUserGroupRoleList = true
            console.log('url', this.$store.state[this.entityName].baseModuleUrl)
            this.$store.dispatch('api/post', {
                url: this.$_emApiMixin_entityBaseApi("emEmAdmUserGroupRole") + "/editRoleList",
                data: {
                    moduleId: this.userGroupId,
                    addedObjectIds: this.addedRoleIds,
                    deleteObjectIds: this.needDeleteRoleIds
                }
            }).then(() => {
                commonViewsUtil.showSuccess(this, "保存成功");
                this.queryUserGroupRoleList();
                this.editAble = false;
            }).finally(() => this.savingUserGroupRoleList = false);
        }
    }

}
</script>

<style scoped>

</style>
